import YearAccordion from './YearAccordion';

export default YearAccordion;
